import API from "./API";

export default class Dashboard extends API
{
    static async getDashboardEngineer() {
        return this.get("api/admin/dashboard/engineer");
    }
    
    
}